var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 515,
    viewBox: "0 0 290 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.653 234.768L101.903 202.982C89.3159 199.361 80.5555 187.593 80.5555 174.517C80.5555 158.121 93.8472 144.844 110.26 144.844H177.021C189.305 144.844 201.389 148.565 211.458 155.405C217.601 159.529 225.858 158.523 231.094 153.394L266.135 119.194C273.285 112.254 272.278 100.687 264.323 94.5508C239.653 75.2383 208.84 64.4756 177.222 64.375V16.0938C177.222 7.24219 169.972 0 161.111 0H128.889C120.028 0 112.778 7.24219 112.778 16.0938V64.375H110.26C46.118 64.375 -5.43756 119.396 0.503409 184.676C4.73258 231.046 40.177 268.766 84.8854 281.842L188.097 312.018C200.684 315.739 209.444 327.407 209.444 340.483C209.444 356.879 196.153 370.156 179.74 370.156H112.979C100.694 370.156 88.611 366.435 78.5416 359.595C72.3992 355.471 64.1423 356.477 58.9062 361.606L23.8645 395.806C16.7152 402.746 17.7222 414.313 25.677 420.449C50.3472 439.762 81.1597 450.524 112.778 450.625V498.906C112.778 507.758 120.028 515 128.889 515H161.111C169.972 515 177.222 507.758 177.222 498.906V450.424C224.146 449.519 268.149 421.656 283.656 377.298C305.305 315.337 268.955 251.767 210.653 234.768Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 515,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a28043c92ecf7ec9f371c58247ef66cc.svg";
export { ForwardRef as ReactComponent };